import { hasConsentWindow, onTcfEvent } from './inMobiChoice'

/**
 * Resolves once the cookie window is out of the way — so the app prompt
 * (owner, 2026-11-03: cookies first, then the app) never stacks on it:
 *
 * - no consent platform on this page → now;
 * - a stored answer (`tcloaded`) → the window never opens;
 * - the window opened (`cmpuishown`) → when the visitor answers
 *   (`useractioncomplete`);
 * - the platform never reports (blocked, offline) → after `fallbackMs`, so
 *   a broken window does not also hide the prompt for the whole visit.
 *
 * Never rejects.
 */
export const CONSENT_SETTLE_FALLBACK_MS = 6_000

export function whenConsentWindowSettled(
  fallbackMs: number = CONSENT_SETTLE_FALLBACK_MS,
): Promise<void> {
  if (!hasConsentWindow()) return Promise.resolve()
  return new Promise((resolve) => {
    let windowShown = false
    const timer = setTimeout(resolve, fallbackMs)
    const settle = () => {
      clearTimeout(timer)
      resolve()
    }
    onTcfEvent((tcData) => {
      if (tcData.eventStatus === 'cmpuishown') {
        windowShown = true
        clearTimeout(timer)
        return
      }
      if (tcData.eventStatus === 'useractioncomplete') settle()
      else if (tcData.eventStatus === 'tcloaded' && !windowShown) settle()
    })
  })
}
